<template>
	<div>
<!--		New line iem-->
		<new-line-item
				:action="this.newLineItemAction.NEW"
				v-if="createNewLineItemModal"
				v-model="showNewLineItemModal"
				:ndc-number="ndcNumber"
				:container-id="record.fieldData.Container_PK_ID"
				:initial-pack-quantity="1"
				:initial-pack-size="record.fieldData['ZIPackage Size']"
        :initial-schedule=this.schedule
		></new-line-item>
		<b-modal v-model="showExportModal" ok-title="Close" ok-only>
			<div class="text-center">
				<a v-if="exportModalFileType === 'xlsx'" :href="exportModalUrl" target="_blank"
				   :download="exportModalFileName">Download File</a>
				<a v-else :href="exportModalUrl" target="_blank" :download="exportModalFileName">Download File</a>
			</div>
		</b-modal>
		<div class="row">
			<ul class="col-12 nav justify-content-end">
				<li class="nav-item"><a href="" @click.prevent="exportToExcel">Export to Excel
					<font-awesome-icon class="ml-1" icon="file-excel"></font-awesome-icon>
				</a></li>
				<li class="nav-item pl-3"><a href="" @click.prevent="saveAsPdf">Save as PDF
					<font-awesome-icon class="ml-1" icon="file-pdf"></font-awesome-icon>
				</a></li>
			</ul>
		</div>
		<div class="card pb-3">
			<vue-element-loading :active="show"></vue-element-loading>
			<vue-headful
					:title="title">
			</vue-headful>
			<b-modal
					:ok-title="'Move'"
					:cancel-title="'Cancel'"
					v-model="showMoveModal"
					v-if="showMoveModal"
					:ok-disabled="!selectedJob"
					@ok="moveContainer"
					width="600"
			>
			<template #modal-title>
				<h5>Move Container</h5>
				<span class="small">Select A Destination Job</span>
			</template>
				<MoveJobList
						:registration="record.fieldData['Registration Number']"
				></MoveJobList>
			</b-modal>
			<b-modal v-model="showAddModal" v-if="showAddModal" @ok="addLineItem" :ok-disabled="!ndcNumber || ndcNumber.length === 0">
				<template #modal-title><h5>Add Line Item</h5></template>
				<span>Select an NDC Number</span>
				<NDCSelect2
            v-model="ndcNumber"
            @schedule="schedule = $event"
            :registration="record.fieldData['Registration Number']"
        >
        </NDCSelect2>
			</b-modal>
			<b-modal :ok-title="'Yes'" :cancel-title="'No'" v-model="showDeleteModal" v-if="showDeleteModal"
					 @ok="deleteContainer">
				<template #modal-title>
					<h5>Delete Container</h5>
				</template>
				Are you sure you want to delete this container and its related line items?
			</b-modal>
			<b-modal :ok-title="'Yes'" :cancel-title="'No'" v-model="showLockModal" v-if="showLockModal"
					 @ok="lockContainer">
				<template #modal-title></template>
				Are you sure you want to lock this container and its related line items?
			</b-modal>
			<b-modal :ok-title="'Yes'" :cancel-title="'No'" v-model="showUnlockModal" v-if="showUnlockModal"
					 @ok="unlockContainer">
				<template #modal-title></template>
				Are you sure you want to unlock this container and its related line items?
			</b-modal>
			<div class="card-body">
				<div class="card-title">
					<div class="row">
						<h5 v-if="!parentLocked && (accessPrivileges.includes('UNLOCK_CONTAINER') || accessPrivileges.includes('LOCK_CONTAINER'))"
							class="col-4">
							<a v-if="accessPrivileges.includes('UNLOCK_CONTAINER') && locked" href="#"
							   @click.prevent="confirmUnlockContainer">
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock"></font-awesome-icon>
							</a>
							<a v-else-if="accessPrivileges.includes('LOCK_CONTAINER')" href="#"
							   @click.prevent="confirmLockContainer">
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock-open"></font-awesome-icon>
							</a>
							<strong>Container {{ record.fieldData.Container_PK_ID }}</strong>
						</h5>
						<h5 v-else class="col-4">
							<span v-if="locked">
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock"></font-awesome-icon>
							</span>
							<span v-else>
								<font-awesome-icon style="margin-right: 0.5em;" icon="lock-open"></font-awesome-icon>
							</span>
							<strong>Container {{ record.fieldData.Container_PK_ID }}</strong>
						</h5>
						<h5 class="col-8">
							<div class="float-right"><strong>Container Name {{ record.fieldData['Container Name'] }}</strong></div>
						</h5>
					</div>
				</div>
				<FeedbackPanel></FeedbackPanel>
				<div class="row">
					<ul v-show="!locked" class="nav col-12 justify-content-end">
						<li v-show="accessPrivileges.includes('MOVE_CONTAINER') && !locked && hasRegistration"
							class="nav-item mr-3">
							<a href="" @click.prevent="showMoveContainer">Move Container
								<font-awesome-icon class="ml-1" icon="dolly"></font-awesome-icon>
							</a>
						</li>
						<li v-show="accessPrivileges.includes('DELETE_CONTAINER') && !locked" class="nav-item">
							<a href="" @click.prevent="confirmDeleteContainer">Delete Container
								<font-awesome-icon class="ml-1" icon="times-circle"></font-awesome-icon>
							</a>
						</li>
					</ul>
				</div>
				<div class="row">
					<div class="col-12">
						<div class="card mb-3">
							<div class="card-body">
								<div class="row">
									<div class="col-2">
										<div><strong>Company ID</strong></div>
										<div class="job-field">{{ record.fieldData['Company::Company_PK_ID'] }}</div>
									</div>
									<div class="col-2">
										<div><strong>Company Name</strong></div>
										<div class="job-field">{{ record.fieldData['Company::Company Name'] }}</div>
									</div>
									<div class="col-2">
										<div><strong>Activity</strong></div>
										<div class="job-field">{{ record.fieldData['Job::Activity'] }}</div>
									</div>
									<div class="col-2">
										<div><strong>Registration</strong></div>
										<div :class="{'text-danger': expired}" class="job-field">
											{{ record.fieldData['Registration Number'] }}
										</div>
									</div>
									<div class="col-2">
										<div><strong>Job ID</strong></div>
										<div class="job-field">
											<router-link
													:to="{name: 'job-view', params: {id: parentRecordString}}">
												{{ record.fieldData['Job ID'] }}
											</router-link>
										</div>
									</div>
									<div class="col-2">
										<div><strong>Job Name</strong></div>
										<div class="job-field">{{ record.fieldData['Job::Job Name'] }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<router-view
							@set-edit-mode="setEditMode"
							@update-record="updateRecord"
							:key="$route.fullPath"
							:record="record"
							:record-id="recordId"
							:locked="locked"
							:entity="'container'"
					></router-view>
					<div class="col-lg-9 col-sm-12">
						<div class="card">
							<div class="card-header pt-2 pb-2">
								<span>Line Items</span>
								<span class="float-right">
									<a href="#"
									   v-if="accessPrivileges.includes('CREATE_LINE_ITEM') && !locked && !expired"
									   @click="selectNdcOnAddItem">
									Add Line Item <font-awesome-icon icon="plus-circle"></font-awesome-icon>
								</a>
								</span>
							</div>
							<div class="card-body pt-1">
								<div class="pb-1">
									<span class="small" style="display: inline-block;">
										Show
									</span>
									<b-form-select
											v-model="itemRowsPerPage"
											:options="rowsPerPageOptions"
											size="sm"
											style="width: auto; display: inline-block;"
											class="mr-2 ml-2"
											plain
									></b-form-select>
									<span class="small" style="display: inline-block;">
										entries
									</span>
								</div>
								<b-table
										:fields="itemTableFields"
										:items="record.portalData.CN_LI"
										:per-page="itemRowsPerPage"
										:current-page="itemPage"
										small
										responsive
										hover
										id="item-table"
								>
									<template v-slot:head(locked)="data">
											<span>
												<font-awesome-icon icon="lock"></font-awesome-icon>
											</span>
									</template>
									<template v-slot:cell(locked)="data">
											<span>
												<span v-if="data.item['CN_LI::Locked Container Line Item'] === 'Yes'"><font-awesome-icon
														icon="lock"></font-awesome-icon></span>
											</span>
									</template>
									<template v-slot:cell(view)="data">
										<b-link
												:to="{name: 'line-item-view', params: {id: data.item.recordId}}">
											<font-awesome-icon icon="eye"></font-awesome-icon>
										</b-link>
									</template>
									<template v-slot:cell(CN_LI::Locked Container Line Item)="data">
										<font-awesome-icon
												v-if="data.item['CN_LI::Locked Container Line Item'] === 'Yes'"
												icon="lock"></font-awesome-icon>
										<span v-else>&nbsp;</span>
									</template>
								</b-table>
								<div v-if="itemMaxRows > 0"
									 style="font-size: smaller; float: left; top: 0.5em; position: relative;">
									Showing
									{{
										itemMaxRows === 0 ? 0 : itemRowsPerPage
												* (itemPage - 1) + 1
									}} to {{
										Math.min(itemRowsPerPage * itemPage,
												itemMaxRows)
									}} of
									{{ itemMaxRows }} entries
								</div>
								<b-pagination
										size="sm"
										:total-rows="itemMaxRows"
										:per-page="itemRowsPerPage"
										v-model="itemPage"
										align="right"
								></b-pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import feedbackMixin from '../mixins/feedback'
import detailViewMixin from '../mixins/detail-view'
import newLineItemActionMixin from '../mixins/new-line-item-action'
import PortalGrid from '../components/PortalGrid'
import FeedbackPanel from '../components/FeedbackPanel';
import DatePicker from '../components/DatePicker'

import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import NDCSelect2 from "../components/NDCSelect2";
import exportFileMixin from "../mixins/export-file";
import MoveJobList from "./container/MoveJobList";
import {EventBus} from "@/event-bus";
import NewLineItem from "@/components/NewLineItem";

Vue.use(VueAxios, axios);

Vue.use(VueMoment, {
	moment,
});

export default {
	name: "Container",
	mixins: [feedbackMixin, detailViewMixin, exportFileMixin, newLineItemActionMixin],
	components: {NewLineItem, MoveJobList, NDCSelect2, DatePicker, FeedbackPanel, PortalGrid},
	mounted() {
		let vm = this
		EventBus.$on('line-item-created', this.onLineItemCreated)
		EventBus.$on('container-edited', this.editRecord)
		EventBus.$on('job-selected', function (job) {
			vm.selectedJob = job.job_id
		})
	},
	destroyed() {
		EventBus.$off('container-edited', this.editRecord)
		EventBus.$off('job-selected')
	},
	computed: {
		parentRecordString: function () {
			return this.record.fieldData['Job::Record_ID'] ? this.record.fieldData['Job::Record_ID'].toString() : '0'
		},
		expired: function () {
			let expDateString = this.record.fieldData['Registration::Expiration Date'];
			let expDate = moment(expDateString, 'MM/DD/YYYY');
			let now = moment().startOf('day');
			return expDate.isBefore(now)
		},
		locked: function () {
			return this.record.fieldData['Locked Container'] && this.record.fieldData['Locked Container'].toUpperCase() === 'YES' ||
				this.parentLocked
		},
		parentLocked: function () {
				return this.record.fieldData['Job::Locked Job'] && this.record.fieldData['Job::Locked Job'].toUpperCase() === 'YES';
		},
		hasRegistration: function () {
			return this.record.fieldData['Registration Number'] && this.record.fieldData['Registration Number'].length > 0
		},
		itemMaxRows: function () {
			if (this.record.portalData.CN_LI) {
				let length = this.record.portalData.CN_LI.length;
				console.log('Max rows ' + length);
				return length
			} else {
				return 50
			}
		},
		title: function () {
			return this.record.fieldData['Container Name']
		}
	},
	methods: {
		onLineItemCreated(event) {
			console.log('Container line item created')
			this.$router.push({path: `/line-item/${event.recordId}`})
		},
		closeNewLineItemModal() {
			this.createNewLineItemModal = false
		},
		showMoveContainer: function () {
			this.clearErrors()
			this.showMoveModal = true
		},
		moveContainer: function () {
			console.log('Moving container to selected job ' + this.selectedJob);
			this.showMoveModal = false
			if (this.selectedJob.length > 0) {
				this.axios.put('/3ds/api/container/move',
					{
						jobId: this.selectedJob,
						containerId: this.record.fieldData['Container_PK_ID']
					},
					{
						Authorization: 'Bearer ' + this.token
					}
				)
					.then(value => {
						console.log('Successfully moved container to job ' + this.selectedJob)
						console.log(JSON.stringify(value));
						let recordId = value.data.recordId;
						this.getRecord(recordId)
							.then(value => {
								console.log('Successfully retrieved record ' + recordId)
								console.log(JSON.stringify(value))
								this.record = value.data.data[0]
							})
							.catch(error => {
								console.error('An error occurred retrieving record ' + recordId)
								console.error(JSON.stringify(error))
							})
					})
					.catch(reason => {
						let msg = 'Failed to move container to job ' + this.selectedJob;
						console.error(msg)
						console.error(JSON.stringify(reason))
						this.pushError({
							message: msg,
							type: 'WARNING'

						})
					})
					.finally(() => {
						this.showMoveModal = false
						this.show = false
					})
			}
		},
		exportToExcel: function () {
			let quickFind = false;
			let searchCriteria = [{id_container: '==' + this.record.fieldData['Container_PK_ID']}];
			let restEntity = 'line-items';
			this.exportFile(searchCriteria, quickFind, restEntity, 'xlsx')
		},
		saveAsPdf: function () {
			let quickFind = false;
			let searchCriteria = [{id_container: '==' + this.record.fieldData['Container_PK_ID']}];
			let restEntity = 'line-items';
			this.exportFile(searchCriteria, quickFind, restEntity)
		},
		lockContainer: function () {
			this.show = true;
			let vm = this;
			let recordId = this.recordId;
			this.axios.patch(`/3ds/api/container/lock/${recordId}`)
				.then(value => {
					console.log('Successfully locked container with record ID ' + recordId)
					console.log(JSON.stringify(value))
					this.getRecord(recordId)
						.then(value => {
							this.record = value.data.data[0]
						})
						.catch(reason => {
							console.error('An error occurred while retrieving a container with record ID ' + recordId);
							console.error(JSON.stringify(reason));
						})
				})
				.catch(reason => {
					console.error('Failed to lock container with record ID ' + recordId)
					console.error(JSON.stringify(reason))
				})
				.finally(() => {
					vm.showLockModal = false;
					vm.show = false
				})
		},
		unlockContainer: function () {
			this.show = true;
			let vm = this;
			let recordId = this.recordId;
			this.axios.patch(`/3ds/api/container/unlock/${recordId}`)
				.then(value => {
					console.log('Successfully unlocked container with record ID ' + recordId)
					console.log(JSON.stringify(value))
					this.getRecord(recordId)
						.then(value => {
							this.record = value.data.data[0]
						})
						.catch(reason => {
							console.error('An error occurred while retrieving a container with record ID ' + recordId);
							console.error(JSON.stringify(reason));
						})
				})
				.catch(reason => {
					console.error('Failed to unlock container with record ID ' + recordId)
					console.error(JSON.stringify(reason))
				})
				.finally(() => {
					vm.showUnlockModal = false;
					vm.show = false
				})
		},
		deleteContainer: function () {
			let vm = this;
			let parentRecordId = vm.record.fieldData['Job::Record_ID'];
			let recordId = this.recordId;
			this.deleteRecord(recordId)
				.then(value => {
					console.log('Successfully deleted container with record ID ' + recordId)
					console.log(JSON.stringify(value))
					vm.$router.push({name: 'job-view', params: {id: parentRecordId.toString()}})
				})
				.catch(reason => {
					console.error('Failed to delete container with record ID ' + recordId);
					console.error(JSON.stringify(reason))
				})
				.finally(() => {
					vm.showDeleteModal = false
				})

		},
		confirmDeleteContainer: function () {
			this.showDeleteModal = true
		},
		confirmLockContainer: function () {
			this.showLockModal = true
		},
		confirmUnlockContainer: function () {
			if (!this.parentLocked) {
				this.showUnlockModal = true
			} else {
				console.log('WTF!')
			}
		},
		goToPage: function (event) {
			if (event) {
				this.itemPage = event.page
			}
		},
		updateRowsPerPage: function (event) {
			if (event) {
				this.itemRowsPerPage = event.limit;
				this.goToPage(event)
			}
		},
		selectNdcOnAddItem: function () {
			this.showAddModal = true
		},
		addLineItem: function () {
			this.showAddModal = false
			this.createNewLineItemModal = true
			this.showNewLineItemModal = true
		}
	},
	data() {
		return {
			createNewLineItemModal: false,
			showNewLineItemModal: false,
			showMoveModal: false,
			selectedJob: '',
			restEntity: 'container',
			restViewEntity: 'container-view',
			portals: [
				{
					name: 'CN_LI',
					limit: 1000,
				}
			],
			itemPortalName: 'CN_LI',
			itemTitle: 'Line Items',
			itemRestDetailEntity: 'line-item-view',
			itemFooter: true,
			itemHeader: true,
			itemLockedColumn: true,
			itemPage: 1,
			itemRowsPerPage: 10,
			itemColumns: [
				{
					name: 'CN_LI::Locked Container Line Item',
					displayName: 'Locked',
					sort: 0,
					locked: true
				},
				{
					name: 'CN_LI::YI NDC Breakdown',
					displayName: 'NDC',
					sort: 0
				},
				{
					name: 'CN_LI::NDC Schedule',
					displayName: 'Schedule',
					sort: 0
				},
				{
					name: 'CN_LI::NDC Description',
					displayName: 'Description',
					sort: 0
				},
				{
					name: 'CN_LI::id',
					displayName: 'ID',
					sort: 0
				}
			],
			itemTableFields: [
				{
					key: 'locked',
					label: '',
					sortable: true,
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'view',
					label: ' ',
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'CN_LI::NDC Number',
					label: 'NDC',
					sortable: true
				},
				{
					key: 'CN_LI::NDC Schedule',
					label: 'Schedule',
					sortable: true
				},
				{
					key: 'CN_LI::NDC Description',
					label: 'Description',
					sortable: true
				},
				{
					key: 'CN_LI::id',
					label: 'ID',
					sortable: true
				}
			],
			showAddModal: false,
			showDeleteModal: false,
			showLockModal: false,
			showUnlockModal: false,
			show: false,
			ndcNumber: '',
      schedule: '',
			rowsPerPageOptions: [
				{
					value: 10,
					text: '10'
				},
				{
					value: 25,
					text: '25'
				},
				{
					value: 50,
					text: '50'
				},
				{
					value: 100,
					text: '100'
				},
			]
		}
	}
}
</script>

<style scoped>
html, body {
    min-height: 100%;
}

body {
    position: relative;
}
</style>